import {UserSubscriptionStatus} from "./UserSubscriptionStatus";

enum UserAddOnSubscriptionStatus {
	ACTIVE = "active",
	INACTIVE = "inactive",
	TO_BE_CANCELLED = "to_be_cancelled",
	CANCELLED = "cancelled",
	SUBSCRIPTION_CANCELLED = "subscription_cancelled",
	SUBSCRIPTION_TO_BE_CANCELLED = "subscription_to_be_cancelled",
}

const names = {
	[UserAddOnSubscriptionStatus.ACTIVE]: "Active",
	[UserAddOnSubscriptionStatus.INACTIVE]: "Inactive",
	[UserAddOnSubscriptionStatus.TO_BE_CANCELLED]: "Cancellation pending",
	[UserAddOnSubscriptionStatus.CANCELLED]: "Cancelled",
	[UserAddOnSubscriptionStatus.SUBSCRIPTION_CANCELLED]:
		"Subscription cancelled",
	[UserAddOnSubscriptionStatus.SUBSCRIPTION_TO_BE_CANCELLED]:
		"Subscription cancellation pending",
};

const colors = {
	[UserAddOnSubscriptionStatus.ACTIVE]: "green",
	[UserAddOnSubscriptionStatus.INACTIVE]: "red",
	[UserAddOnSubscriptionStatus.TO_BE_CANCELLED]: "magenta",
	[UserAddOnSubscriptionStatus.CANCELLED]: "magenta",
	[UserAddOnSubscriptionStatus.SUBSCRIPTION_CANCELLED]: "magenta",
	[UserAddOnSubscriptionStatus.SUBSCRIPTION_TO_BE_CANCELLED]: "magenta",
};

const mapSubscriptionStatus = {
	[UserSubscriptionStatus.ACTIVE]: UserAddOnSubscriptionStatus.ACTIVE,
	[UserSubscriptionStatus.CANCELED]: UserAddOnSubscriptionStatus.CANCELLED,
	[UserSubscriptionStatus.PAST_DUE]: UserAddOnSubscriptionStatus.INACTIVE,
	[UserSubscriptionStatus.PAUSED]: UserAddOnSubscriptionStatus.INACTIVE,
	[UserSubscriptionStatus.TRIALING]: UserAddOnSubscriptionStatus.ACTIVE,
};

const fromSubscriptionStatus = (status: UserSubscriptionStatus) =>
	mapSubscriptionStatus[status];

const displayUserAddOnSubscriptionStatus = (
	status: UserAddOnSubscriptionStatus
) => names[status];

const colorUserAddOnSubscriptionStatus = (
	status: UserAddOnSubscriptionStatus
) => colors[status];

const cancellationPendingUserAddOnSubscriptionStatuses = (
	status: UserAddOnSubscriptionStatus
) =>
	[
		UserAddOnSubscriptionStatus.TO_BE_CANCELLED,
		UserAddOnSubscriptionStatus.SUBSCRIPTION_TO_BE_CANCELLED,
	].includes(status);

const cancelledUserAddOnSubscriptionStatuses = (
	status: UserAddOnSubscriptionStatus
) =>
	[
		UserAddOnSubscriptionStatus.CANCELLED,
		UserAddOnSubscriptionStatus.SUBSCRIPTION_CANCELLED,
	].includes(status);

export {
	UserAddOnSubscriptionStatus,
	displayUserAddOnSubscriptionStatus,
	colorUserAddOnSubscriptionStatus,
	fromSubscriptionStatus,
	cancellationPendingUserAddOnSubscriptionStatuses,
	cancelledUserAddOnSubscriptionStatuses,
};
